import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShield: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShield"><Path d="M12 1.95898L3 4.95898V11.9119C3 14.6493 4.18351 16.6696 5.85876 18.2592C7.5058 19.822 9.65956 20.997 11.6439 22.0675L12 22.2596L12.3561 22.0675C14.3404 20.997 16.4942 19.822 18.1412 18.2592C19.8165 16.6696 21 14.6493 21 11.9119V4.95898L12 1.95898Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShield;
